import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=164455ac&lang=pug&"
import script from "./BaseText.vue?vue&type=script&lang=js&"
export * from "./BaseText.vue?vue&type=script&lang=js&"
import style0 from "./BaseText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports